export const fuelSlotRequestsHeaderElements = [
  { label: "Fecha entrega", value: "fechaEntrega", align: "inherit" },
  { label: "Titular cuenta", value: "titularCuenta", align: "inherit" },
  { label: "Cant. Litros", value: "cantidad", align: "inherit" },
  { label: "Destino", value: "destino", align: "inherit" },
  { label: "Depósito", value: "nombreDeposito", align: "inherit" },
  { label: "Tipo", value: "tipo", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
